type FileName = 'inventory item' | 'venue';
type UploadResponse = { added: number; updated: number };

const fileText = (value: number, fileName: string): string => {
  if (value === 1) {
    return `${value} ${fileName}`;
  } else {
    return `${value} ${fileName}s`;
  }
};

export const fileUploadMessage = (fileName: FileName, response: UploadResponse): string => {
  if (response.added > 0 && response.updated > 0) {
    return `You have successfully imported ${fileText(response.added, fileName)} and updated ${fileText(response.updated, fileName)}.`;
  } else if (response.added === 0 && response.updated === 0) {
    return `No new ${fileName}s imported or updated.`;
  } else {
    return `You have successfully ${response.added > 0 ? 'imported' : 'updated'} ${
      response.added > 0 ? fileText(response.added, fileName) : fileText(response.updated, fileName)
    }.`;
  }
};
